import React from "react";
import { ChevronLeft, LogOut, Menu, X } from "lucide-react";
import fullLogo from "../../../assets/images/fullLogo.svg";

const DashboardSidebar = ({
  navItems,
  activeSection,
  setActiveSection,
  collapsed,
  setCollapsed,
  sidebarOpen,
  setSidebarOpen,
  onLogout,
  t,
}) => {
  return (
    <>
      <div className="lg:hidden fixed top-0 left-0 right-0 flex items-center justify-between px-4 py-3 bg-white border-b border-slate-200 z-50">
        <img src={fullLogo} alt="IRQGYP" className="h-8 w-auto" />
        <button
          type="button"
          onClick={() => setSidebarOpen((v) => !v)}
          className="p-2 rounded-lg border border-slate-300 text-slate-700"
          aria-label="Toggle sidebar"
        >
          {sidebarOpen ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {sidebarOpen && (
        <button
          type="button"
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 bg-slate-900/40 z-40 lg:hidden"
          aria-label="Close sidebar overlay"
        />
      )}

      <aside
        className={[
          "fixed lg:static top-0 left-0 z-50 h-dvh lg:h-screen bg-[#0b1f3f] text-white transition-all duration-300",
          "w-[86vw] max-w-[320px] lg:max-w-none",
          collapsed ? "lg:w-[88px]" : "lg:w-[280px]",
          sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0",
        ].join(" ")}
      >
        <div className="h-full flex flex-col overflow-hidden">
          <div className="h-16 px-4 flex items-center justify-between border-b border-white/10">
            <img src={fullLogo} alt="IRQGYP" className={`h-8 w-auto ${collapsed ? "hidden" : "block"}`} />
            <button
              type="button"
              onClick={() => setCollapsed((v) => !v)}
              className="hidden lg:inline-flex p-2 rounded-lg hover:bg-white/10"
              aria-label="Collapse sidebar"
            >
              <ChevronLeft className={collapsed ? "rotate-180 transition" : "transition"} />
            </button>
          </div>

          <nav
            className="px-3 py-4 space-y-2 flex-1 overflow-y-auto [scrollbar-width:thin] [scrollbar-color:#3f5478_transparent] [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-[#3f5478] [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-[#58729f]"
          >
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = activeSection === item.id;
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => {
                    setActiveSection(item.id);
                    setSidebarOpen(false);
                  }}
                  className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl text-left transition ${
                    isActive ? "bg-white/20" : "hover:bg-white/10"
                  }`}
                >
                  <Icon size={18} />
                  {!collapsed && <span className="text-sm font-medium">{item.label}</span>}
                </button>
              );
            })}
          </nav>

          <div className="p-3 border-t border-white/10">
            <button
              type="button"
              onClick={onLogout}
              className="w-full flex items-center gap-3 px-3 py-3 rounded-xl text-left hover:bg-white/10 transition"
            >
              <LogOut size={18} />
              {!collapsed && <span className="text-sm font-medium">{t("dashboard.logout")}</span>}
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default DashboardSidebar;
